import React, {useState} from 'react';
import {useDialog, useTranslate} from '../../../hooks';
import {FlexOfferDialogUpdate} from './FlexOfferDialogUpdate';
import {FlexOfferDialogSuccess} from './FlexOfferDialogSuccess';
import {BaseDialog, KeyRouter} from '@resurs-internal/mui';

export type FlexOfferDialogRoutes = 'update' | 'success' | 'close';
export const FlexOfferDialog: React.FC = () => {
  const translate = useTranslate();
  const {open, onClose} = useDialog('flex-offer');
  const [routeKey, setRouteKey] = useState('update');
  const navigate = (key: FlexOfferDialogRoutes) => {
    if (key === 'close') {
      onClose();
      setRouteKey('update');
      return;
    }
    setRouteKey(key);
  };

  return (
    <BaseDialog
      header={translate('flex.offer.header')}
      open={open}
      onClose={onClose}>
      <KeyRouter
        current={routeKey}
        routes={{
          update: <FlexOfferDialogUpdate navigate={navigate} />,
          success: <FlexOfferDialogSuccess navigate={navigate} />,
        }}
      />
    </BaseDialog>
  );
};
